import { toast as sonner } from 'sonner';

/**
 * Latio toast helpers — DESIGN_SYSTEM.md §7/§8.
 * Success/error/indigo tones; Undo on reversible ops.
 */

const TONE_STYLE = {
  success: { borderLeft: '3px solid var(--latio-success)' },
  error: { borderLeft: '3px solid var(--latio-error)' },
  indigo: { borderLeft: '3px solid var(--latio-indigo)' },
} as const;

export function toastSuccess(message: string, description?: string) {
  return sonner.success(message, { description, style: TONE_STYLE.success });
}

export function toastError(message: string, description?: string) {
  return sonner.error(message, { description, style: TONE_STYLE.error });
}

/** Indigo-toned informational/confirmation toast (e.g. Reactivate). */
export function toastInfo(message: string, description?: string) {
  return sonner(message, { description, style: TONE_STYLE.indigo });
}

/**
 * Reversible-action toast with an Undo button (DESIGN_SYSTEM §8).
 * `onUndo` runs if the user clicks Undo before the toast dismisses.
 */
export function toastUndo(
  message: string,
  onUndo: () => void,
  opts?: { description?: string; tone?: keyof typeof TONE_STYLE; duration?: number },
) {
  const tone = opts?.tone ?? 'success';
  return sonner(message, {
    description: opts?.description,
    duration: opts?.duration ?? 6000,
    style: TONE_STYLE[tone],
    action: {
      label: 'Undo',
      onClick: onUndo,
    },
  });
}

export { sonner as toast };
